import React from "react";
import { Container, Stack } from "react-bootstrap";

import teamMembers from "../data/TeamMembers.json";
import previousTeams from "../data/PreviousTeams.json";
import { TeamMembers } from "../components/TeamMember";
import { PageTitle } from "../components/PageTitle";
import { PreviousTeams } from "../components/PreviousTeams";

export default function About() {
  return (
    <Container className="page-container"  id="about">
      <Stack gap={2}>
        <PageTitle title={"The Team"} />
        <Container>
          <Stack gap={2}>
            <h4 style={{ marginTop: "10px" }}>Current Team Members</h4>
            <TeamMembers allTeamMembers={teamMembers} />
          </Stack>
        </Container>
        <Container style={{ marginTop: 50 }}>
          <h4>Previous Teams</h4>
          <Stack style={{ marginTop: 20 }} gap={5}>
            <PreviousTeams teams={previousTeams} />
          </Stack>
        </Container>
      </Stack>
    </Container>
  );
};
